import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import SplitTests from "../../components/split-tests/split-tests";
import SplitTestDashboard from "../../components/split-tests/split-test-dashboard";
import { SPLIT_TEST_TABS } from "../../components/strings";

const SplitTestsPage = () => {
  return (
    <>
      <Routes>
        <Route element={<SplitTests />}>
          <Route
            path="lead"
            element={<SplitTestDashboard funnelType={SPLIT_TEST_TABS.LEAD} />}
          />
          <Route
            path="employee"
            element={
              <SplitTestDashboard funnelType={SPLIT_TEST_TABS.EMPLOYEE} />
            }
          />
          <Route path="*" element={<Navigate to="lead" />} />
        </Route>
      </Routes>
      <Outlet />
    </>
  );
};
export default SplitTestsPage;
